import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Nav from './../components/Nav';
import { database, auth } from '../firebase';

class Yazarlar extends Component {
  constructor(props) {
    super(props);
    this.database = database.ref().child('users');
    this.postsDatabase = database.ref().child('posts');
    this.state = {
      users: [],
      posts: [],
    };
  }

  componentWillMount() {
    const previousUsers = [];

    this.database.on('child_added', snap => {
      if (snap.val().verified === true) {
        const userId = snap.key;

        const posts = [];
        this.postsDatabase.on('child_added', postSnap => {
          if (postSnap.val().postAuthor === userId) {
            const post = postSnap.val();
            const likeCount = post.likes || 0;

            posts.push({
              ...post,
              likeCount,
            });
          }
        });

        setTimeout(() => {
          previousUsers.push({
            id: userId,
            userName: snap.val().userName,
            uid: snap.val().uid,
            bio: snap.val().bio,
            userEmail: snap.val().email,
            userImage: snap.val().userImage,
            verified: snap.val().verified,
            postCount: posts.length,
            posts: posts,
          });

          this.setState({
            users: previousUsers,
          });
        }, 500);
      }
    });
  }

  render() {
    return (
      <>
        <Nav />
        <div className="hero">
          <p className="asdf">Yazarlar</p>
        </div>
        <div className="main">
          {this.state.users.length > 0 ? this.state.users.map((user) => (
            <Link to={`/profil/` + user.id} key={user.id}>
              <div className="card">
                <img src={user.userImage || "/default.jpg"} className="banner" alt="Yazının Görseli" />
                <b className="başlık">{user.userName}</b>
                <div className="post-count">{user.postCount} yazı paylaştı.</div>
                {user.posts.likeCount}
              </div>
            </Link>
          )).reverse() : <img src="/loading.svg" className="loading-non" />}
        </div>
    <style>{`
      .main {
        max-width: 762px;
        width: 100%;
        margin: 0 auto;
        margin-top: 0px;
        padding: 0;
        padding-bottom: 52px;
        text-align: center;
      }

      .hero {
        background: url(/.png);
        background-size: cover;
        padding: 50px 100px;
        padding: 20px 100px;
        margin: 0 auto;
        margin-top: 52px;
        max-width: 730px;
      }
     
      .asdf {
        text-align: center;
        padding: 10px;
        font-size: 50px;
        display: none;
      }

      .h2 {
        margin: 30% 0;
        text-align: center;
        display: none;
      }
      
      .card {
        border-radius: 20px;
        border-radius: 20px 7px 20px 7px;
        margin: 10px 10px;
        padding: 15px;
        background: #F57029;
        box-shadow: 0px 0px 4px rgba(0,0,0,.0);
        width: 200px;
        max-width: 200px;
        height: 260px;
        display: inline-block;
        transition: .2s;
      }

      .card:hover {
        background: #d95e1c;
      }

      .card .banner {
        display: block;
        border-radius: 100%;
        margin: auto;
        margin-top: 10px;
        width: 170px;
        height: 170px;
        object-fit: cover;
      }

      .başlık {
        display: block;
        margin-top: 20px;
        color: #fff;
        text-align: center;
        font-size: 30px;
        font-weight: 600;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .post-count {
        color: #eee;
        font-weight: 600;
      }

      @media (max-width: 623px) {
        .hero {
          width: 100%;
          position: fixed;
          z-index: 1;
          color: #fff;
          background: #2f2d33;
          height: 50px;
          padding: 0;
          margin: 0;
          display: flex;
        }

        .asdf {
          margin: 0;
          margin-left: 10px;
          line-height: 50px;
          padding: 0;
          font-size: 20px;
          display: block;
        }

        .main {
          width: 100%;
          max-width: 80%;
          padding-top: 80px;
        }

        .card {
          width: 100%;
          height: auto;
          max-width: 90%;
          margin: 15px 0px;
          display: flex;
          flex-wrap: wrap;
        }

        .card .banner {
          width: 52px;
          height: 52px;
          margin: 0;
          margin-right: 10px;
        }

        .başlık {
          font-size: 26px;
          margin-top: 10px;
        }

        .post-count {
          margin-top: 5px;
        }
      }
    `}</style>
  </>
)}};

export default Yazarlar;